import {
    GET_LEADS,
    GET_SINGLE_LEADS,
    LEADS_ERROR,
    LEADS_LOADER,
    SET_CURRENT_LEAD_ID,
} from "../actionType";

let initialState = {
    loading: false,
    error: null,
    leads: [],
    singleLead: null,
    currentLeadId: null,
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case LEADS_LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case LEADS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_SINGLE_LEADS:
            return {
                ...state,
                loading: false,
                singleLead: payload,
                error: null,
            };
        case GET_LEADS:
            return {
                ...state,
                loading: false,
                leads: {
                    data: [...payload.leads],
                    pagination: payload.pagination,
                    counts: payload.counts
                },
                error: null,
            };
        case SET_CURRENT_LEAD_ID:
            return { ...state, currentLeadId: payload };
        default:
            return state;
    }
};
